import { useQuery } from '@tanstack/react-query';

import { getAccountTaxId } from '@arrived/api_v2';
import { AccountId } from '@arrived/models';

import { UseQueryOptions } from '../../queries.utils';
import { accountsTaxIdKeyFn } from '../accounts.keys';

export function useGetAccountTaxIdQuery(accountId?: AccountId, options?: UseQueryOptions<string>) {
  return useQuery(accountsTaxIdKeyFn(accountId!), () => getAccountTaxId(accountId!), {
    ...options,
    enabled: (options?.enabled ?? true) && accountId != null,
  });
}
